import React from 'react';
import { MetricsElement } from 'react-metrics';

import CompareButton from '../../compare/components/compare-button';
import withCompare from '../../compare/components/compare-container';
import SaleCallOut from './product-salecallout';
import ProductImage from './product-image';
import ProductDetailRow from './product-detail-row';
import KspList from './ksp-list';
import InventoryMessage from './inventory-message';
import ProductPrice from './product-price';
import SpecialOffers from './special-offers';
import IntraDayDeals from './deals';
import { Helpers } from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';
import Link from '../../shared/components/hyperlink';
import ProductCTA from './product-cta';
import TechSpecs from './tech-specs';
import ViolatorMessage from './product-violator';
import { ModalControl } from '../../context/modal/modal-context';
import ProductJsonLd from './product-json-ld';

import '../css/product-show.less';

class ProductCard extends React.PureComponent {
    state = {
        showOffers: false,
        isSelected: false,
    };

    constructor(props) {
        super(props);
        this.getTechSpecs = this.getTechSpecs.bind(this);
        this.handleCompareChange = this.handleCompareChange.bind(this);
    }

    handleCompareChange(isSelected) {
        if (typeof isSelected === 'undefined') {
            this.setState(prevState => ({ isSelected: !prevState.isSelected }));
        } else if (typeof isSelected === 'boolean') {
            this.setState({ isSelected });
        }
    }

    getTechSpecs() {
        this.props.openSpecs(this.props.product.sku);
    }

    render() {
        let { enableAppPDP, product, jumpInfo, className, saleCalloutPath, hideMktDiff, productIndex } = this.props;
        const { metadata = {} } = product;
        let urlParams = Helpers.getPDPJumpId(product, jumpInfo);
        let isParentPrd = product.prdClass === 'PRT';
        //with app hosted pdp, pdp links should no longer explicitly be absolue
        const linkType = 'relative'; //enableAppPDP || isParentPrd ? 'relative' : 'absolute';
        const selectClass = this.state.isSelected ? ' compare-selected' : '';

        return (
            <div className={'product-card' + className + selectClass} data-sku={product.sku}>
                <ProductJsonLd product={product} />
                <IntraDayDeals itemId={product.itemId}>
                    {dealProps => {
                        const { isActive, productDeals, IntraDayBanner } = dealProps;
                        const deal = isActive ? productDeals.activeDeal : null;
                        if (isActive) {
                            urlParams.dl = true;
                        }

                        let productUrl = Helpers.addUrlParam(`/pdp/${product.slug}`, urlParams);

                        return (
                            <React.Fragment>
                                {isActive ? (
                                    <IntraDayBanner deals={productDeals} message={metadata.intraDayMessage} product={product} />
                                ) : (
                                    <SaleCallOut
                                        product={product}
                                        callout={saleCalloutPath ? product[saleCalloutPath] : null}
                                    />
                                )}
                                <ProductImage
                                    link={productUrl}
                                    linkType={linkType}
                                    product={product}
                                    maxImgWidth={270}
                                    productIndex={productIndex}
                                    lazyLoad={false}
                                />
                                <div className="product-details">
                                    <Link to={productUrl} linkType={linkType} className="product-title pdp-link">
                                        <h3 aria-label={product.name}>{product.name}</h3>
                                    </Link>
                                    {!hideMktDiff && (
                                        <ViolatorMessage
                                            className="mkt-diff"
                                            product={product}
                                            clamp={2}
                                            charMaxLength={65}
                                        />
                                    )}
                                    <ProductDetailRow product={product} />
                                    <KspList ksps={product.ksps} />
                                    <div className="specs-and-offers">
                                        <ModalControl
                                            content={TechSpecs}
                                            contentProps={{ sku: product.sku }}
                                            modalProps={{ className: 'tech-specs-modal-container' }}
                                        >
                                            {props => (
                                                <MetricsElement
                                                    element="button"
                                                    className="tech-specs-open unstyled"
                                                    data-metrics-event-name="prodDetailsTab"
                                                    data-metrics-event="e_prodDetailsTab"
                                                    data-metrics-details-tab-name="specs"
                                                    data-metrics-product-name={product.name}
                                                    onClick={props.openModal}
                                                    tabIndex={0}
                                                    aria-label="Tech Spec"
                                                >
                                                    Tech Spec
                                                </MetricsElement>
                                            )}
                                        </ModalControl>
                                        <SpecialOffers product={product} withToolTip={true} />
                                    </div>
                                </div>
                                <div className="prd-footer">
                                    <InventoryMessage product={product} />
                                    <ProductPrice product={product} deal={deal} showPreOrderMsg />
                                    <div className="clearfix">
                                        <ProductCTA
                                            product={product}
                                            jumpid={urlParams.jumpid}
                                            to={metadata.ctaLink}
                                            ctaText={metadata.ctaText}
                                        />
                                        <CompareButton product={product} onCompareChange={this.handleCompareChange} />
                                    </div>
                                </div>
                            </React.Fragment>
                        );
                    }}
                </IntraDayDeals>
            </div>
        );
    }
}

ProductCard.defaultProps = {
    className: '',
    toggleCompareProduct: () => {},
    hideMktDiff: false,
};

export default withCompare(withError(ProductCard));
